import { LitEntity, html } from '../../utility/lit-entity';
import { BnModalMixin } from '../../common/bn-modal-mixin';
import '../../common/bn-action';
import '../../common/bn-flash';
import './bin-height-map-inspector';

class BinHeightMapModal extends BnModalMixin(LitEntity) {
  constructor() {
    super();
    this.id = 'bin-height-map-modal';
  }

  renderContents() {
    const name = this.entity?.properties.name || '';
    return html`
      <style>
        bn-modal#bin-height-map-modal {
          --modal-min-width: calc(100% - 2rem);
          --modal-min-height: calc(100% - 2rem);
          --modal-max-height: calc(100% - 2rem);
          --modal-body--padding: 0;
          --modal-body-display: flex;
        }
        h3 {
          margin: 0;
        }
        #bin-height-map-modal .container {
          /* background-color: var(--white-base); */
          overflow: auto;
          flex-grow: 1;
          padding: 1rem;
        }
        #bin-height-map-modal bin-height-map-inspector {
          height: 100%;
        }
      </style>

      <h3 slot="title">${name}</h3>

      <div class="container">
        <bin-height-map-inspector .href="${this.href}"></bin-height-map-inspector>
      </div>
    `;
  }
}

window.customElements.define('bin-height-map-modal', BinHeightMapModal);
